import { Footer } from 'app/core/footer/Footer';
import { Header } from 'app/core/header/Header';
import React, { useContext, useState } from 'react';
import { Column, Layout, LocaleContext, PageHeader, Row } from 'shared';

import { AuthorizationWrapper } from './Authorization.styles';
import { LoginContainer } from './login/LoginContainer';
import { RegistrationContainer } from './registration/RegistrationContainer';
import { ResetPasswordContainer } from './resetPassword/ResetPasswordContainer';

const LOGIN_FORM = 'LOGIN';
const RESET_PASSWORD_FORM = 'RESET-PASSWORD';
const REGISTRATION_FORM = 'REGISTRATION';

export const Authorization = () => {
  const localeContext = useContext(LocaleContext);
  const [currentForm, setCurrentForm] = useState(LOGIN_FORM);

  const onShowLoginForm = () => {
    setCurrentForm(LOGIN_FORM);
  };

  const onShowResetPasswordForm = () => {
    setCurrentForm(RESET_PASSWORD_FORM);
  };

  const onShowRegistrationForm = () => {
    setCurrentForm(REGISTRATION_FORM);
  };

  return (
    <Layout header={<Header />} footer={<Footer />}>
      <Row height="100%">
        <Column>
          <AuthorizationWrapper className="authorization">
            <Row height="100%">
              <Column size={[0, 3, 3, 4]} />
              <Column size={[12, 6, 6, 4]} className="authorization__content">
                <PageHeader>{localeContext.formatMessage({ id: `${currentForm}.FORM.TITLE` })}</PageHeader>
                {currentForm === LOGIN_FORM && (
                  <LoginContainer
                    onShowResetPasswordForm={onShowResetPasswordForm}
                    onShowRegistrationForm={onShowRegistrationForm}
                  />
                )}
                {currentForm === RESET_PASSWORD_FORM && <ResetPasswordContainer onShowLoginForm={onShowLoginForm} />}
                {currentForm === REGISTRATION_FORM && <RegistrationContainer onShowLoginForm={onShowLoginForm} />}
              </Column>
              <Column size={[0, 3, 3, 4]} />
            </Row>
          </AuthorizationWrapper>
        </Column>
      </Row>
    </Layout>
  );
};
